import { type Connection } from '@blaze-shared/workflow-domain';

export type ConnectionChain = Connection[];

export const getChainId = (chain: ConnectionChain): string | undefined => {
  return chain?.length ? chain[0].chainId : undefined;
};

export const getChainByChainId = (chains: ConnectionChain[], chainId?: string): Connection[] => {
  const chainIndex = getChainIndexByChainId(chains, chainId);
  return chainIndex >= 0 ? [...(chains[chainIndex] || [])] : [];
};

export const getChainIndexByChainId = (chains?: ConnectionChain[], chainId?: string): number => {
  return chainId && chains?.length
    ? chains.findIndex((chain) => !!chain.some((connection) => connection.chainId === chainId))
    : -1;
};

export const chainReferencesWorkflow = (chain: ConnectionChain, workflowId: string): boolean =>
  chain.some(
    (connection) =>
      (connection.source.layerType === 'Workflow' && connection.source.id === workflowId) ||
      (connection.target.layerType === 'Workflow' && connection.target.id === workflowId),
  );
